import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import routes from './routes';
import { usePageStyle } from './styles';

const routesComponent = routes.map(prop => <Route key={`route-${prop.path}`} path={prop.path} component={prop.component} />);

const Pages = () => {
  const classes = usePageStyle();
  return (
    <div className={classes.wrapper}>
      <div className={classes.fullPage}>
        <Switch>
          {routesComponent}
          <Redirect to="/pages/login" />
        </Switch>
      </div>
    </div>
  );
};


export default Pages;
